import * as bootstrap5 from "bootstrap";

export default () => ({

    init() {
        // Activate the tab corresponding to the childId in the URL
        const targetChildId = new URLSearchParams(window.location.search).get('childId');
        if (targetChildId) {
            const targetTab = this.$el.querySelector(`#childrenTabs button[data-child-id="${targetChildId}"]`);
            if (targetTab) new bootstrap5.Tab(targetTab).show();
        }

        // Listen for the custom event dispatched by bootstrap-components.js (Shadow DOM)
        this.$el.addEventListener('tab-shown', (event) => {
            this.onTabShown(event);
        });

    },

    // Resize the calendar on tab change (lazy render FullCalendar)
    onTabShown(event) {
        const childId = event.target.getAttribute('data-child-id');

        const calendarEl = this.$el.querySelector('#calendar-' + childId);
        if (calendarEl && calendarEl._x_dataStack) {
            Alpine.$data(calendarEl).resize();
        }
    }

});